import {
  EnumCommunicationEmojis,
  EnumCommunicationPersonality,
  EnumCommunicationResponseStyle
} from '../enums/communication-preference.enum';

/* eslint-disable @typescript-eslint/naming-convention */
export interface ICommunicationPreferencesRequestRaw {
  emojis: EnumCommunicationEmojis;
  response_style: EnumCommunicationResponseStyle;
  personality: EnumCommunicationPersonality;
  custom_personality: string | null;
}

export interface ICommunicationPreferencesRaw extends ICommunicationPreferencesRequestRaw {
  updated_at: string | null;
}
/* eslint-enable @typescript-eslint/naming-convention */

export interface ICommunicationPreferencesRequest {
  emojis: EnumCommunicationEmojis;
  responseStyle: EnumCommunicationResponseStyle;
  personality: EnumCommunicationPersonality;
  customPersonality: string | null;
}

export interface ICommunicationPreferences extends ICommunicationPreferencesRequest {
  updatedAt: string | null;
}

export const toCommunicationPreferences = (
  raw: ICommunicationPreferencesRaw
): ICommunicationPreferences => ({
  emojis: raw.emojis,
  responseStyle: raw.response_style,
  personality: raw.personality,
  customPersonality: raw.custom_personality,
  updatedAt: raw.updated_at
});

/* eslint-disable @typescript-eslint/naming-convention */
export const toCommunicationPreferencesRequestRaw = (
  request: ICommunicationPreferencesRequest
): ICommunicationPreferencesRequestRaw => ({
  emojis: request.emojis,
  response_style: request.responseStyle,
  personality: request.personality,
  custom_personality: request.customPersonality
});
/* eslint-enable @typescript-eslint/naming-convention */

export const hasKnownCommunicationChoices = (
  preferences: ICommunicationPreferencesRequest
): boolean =>
  Object.values(EnumCommunicationEmojis).includes(preferences.emojis) &&
  Object.values(EnumCommunicationResponseStyle).includes(
    preferences.responseStyle
  ) &&
  Object.values(EnumCommunicationPersonality).includes(preferences.personality);
